import { Dialog } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import SheriffStarMedA from 'src/assets/SheriffStarMedA.png';
import MobileNavDropdown from 'src/components/page/Header/MobileNavDropdown';
import LogoutButton from 'src/components/button/logout';

export default function MobileNav({
  mobileMenuOpen,
  setMobileMenuOpen,
  informationLinks,
  divisionsLinks,
  mediaLinks,
}) {
  return (
    <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
      <div className="fixed inset-0 z-10" />
      <Dialog.Panel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-header-background px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
        <div className="flex items-center justify-between">
          <a href="#" className="-m-1.5 p-1.5">
            <img className="h-10 w-auto" src={SheriffStarMedA} alt="" />
          </a>
          <button
            type="button"
            className="-m-2.5 rounded-md p-2.5 text-white"
            onClick={() => setMobileMenuOpen(false)}
          >
            <span className="sr-only">Close menu</span>
            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <div className="mt-6 flow-root">
          <div className="-my-6 divide-y divide-gray-500/50">
            <div className="space-y-2 py-6">
              <MobileNavDropdown
                title="Divisions"
                links={divisionsLinks}
                topLink="https://sheriff.utahcounty.gov/information/divisions"
              />
              <MobileNavDropdown
                title="Media"
                links={mediaLinks}
                topLink="https://sheriff.utahcounty.gov/media"
              />
              <MobileNavDropdown
                title="Information"
                links={informationLinks}
                topLink="https://sheriff.utahcounty.gov/information"
              />
            </div>
            <div className="py-6 flex justify-between">
              <a
                href="https://member.everbridge.net/1332612387832225/login"
                className="no-underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button
                  type="button"
                  className="flex gap-2 rounded-sm bg-green-bright px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-green-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-bright items-center"
                >
                  Utah County Alerts{' '}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-5 h-5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 110-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 01-1.44-4.282m3.102.069a18.03 18.03 0 01-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 018.835 2.535M10.34 6.66a23.847 23.847 0 008.835-2.535m0 0A23.74 23.74 0 0018.795 3m.38 1.125a23.91 23.91 0 011.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 001.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 010 3.46"
                    />
                  </svg>
                </button>
              </a>
              <LogoutButton />
            </div>
          </div>
        </div>
      </Dialog.Panel>
    </Dialog>
  );
}
